var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAntDesignProductOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#DEDEDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7662 13.0878C18.9392 13.0878 19.0795 13.2281 19.0795 13.4012V19.354C19.0795 19.527 18.9392 19.6673 18.7662 19.6673H12.8133C12.6403 19.6673 12.5 19.527 12.5 19.354V13.4012C12.5 13.2281 12.6403 13.0878 12.8133 13.0878H18.7662ZM17.7479 14.4194H13.8316V18.3357H17.7479V14.4194ZM27.4082 16.1364C27.5306 16.2588 27.5306 16.4572 27.4082 16.5795L23.8635 20.1242C23.7412 20.2466 23.5428 20.2466 23.4205 20.1242L19.8758 16.5795C19.7535 16.4572 19.7535 16.2588 19.8758 16.1364L23.4205 12.5918C23.5428 12.4694 23.7412 12.4694 23.8636 12.5918L27.4082 16.1364ZM25.7467 16.358L23.642 14.2533L21.5374 16.358L23.642 18.4626L25.7467 16.358ZM18.7662 20.9205C18.9392 20.9205 19.0795 21.0608 19.0795 21.2338V27.1867C19.0795 27.3597 18.9392 27.5 18.7662 27.5H12.8133C12.6403 27.5 12.5 27.3597 12.5 27.1867V21.2338C12.5 21.0608 12.6403 20.9205 12.8133 20.9205H18.7662ZM17.7479 22.2521H13.8316V26.1684H17.7479V22.2521ZM26.5989 20.9205C26.7719 20.9205 26.9122 21.0608 26.9122 21.2338V27.1867C26.9122 27.3597 26.7719 27.5 26.5989 27.5H20.646C20.473 27.5 20.3327 27.3597 20.3327 27.1867V21.2338C20.3327 21.0608 20.473 20.9205 20.646 20.9205H26.5989ZM25.5806 22.2521H21.6643V26.1684H25.5806V22.2521Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntDesignProductOutlined);
export default __webpack_public_path__ + "static/media/ant-design_product-outlined.d0e04744a86bbac3b90385e74e908abb.svg";
export { ForwardRef as ReactComponent };